module.exports = __webpack_public_path__ + "img/icon_manejo_escuelas.29cfca5f.svg";